import { render, staticRenderFns } from "./BankAccountData.vue?vue&type=template&id=23908ed5&scoped=true"
import script from "./BankAccountData.vue?vue&type=script&lang=js"
export * from "./BankAccountData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23908ed5",
  null
  
)

export default component.exports